import classNames from 'classnames/bind';
import styles from './SliderModal.module.css';
import { Modal } from '../Modal';
import { IModal } from '../../types/modal';
import { CLOSE_POPUP, NEXT, PREV } from '../../constants';
import Button from '../Button';
import useModal from '../../hooks/useModal';

import { EffectCreative, Navigation } from 'swiper';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import { useSwiperRef } from '../../hooks/useSwiper';

import QuizDetails from '../../pages/Classroom/QuizDetails';
import { openSelpubCloud } from '../../utils/selpub';
import { useState } from 'react';
import { isMobile } from '../../utils/util';
import { quizChanged } from '../../features/analysisSlice';
import { useAppDispatch } from '../../hooks/useRedux';

export default function SliderModal({ id, type, name, data }: IModal) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const { toggleModal } = useModal();

  const { projectId, list, index } = data;

  const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>();
  const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>();

  const [curSlideIndex, setCurSlideIndex] = useState(index);

  const swiperOptions: SwiperProps = {
    wrapperTag: 'ul',
    modules: [Navigation, EffectCreative],
    navigation: {
      prevEl,
      nextEl,
    },
    initialSlide: index,
    grabCursor: true,
    effect: 'creative',
    creativeEffect: {
      prev: {
        translate: [0, 0, -400],
      },
      next: {
        translate: ['100%', 0, 0],
      },
    },
    onSlideChange(swiper) {
      const { activeIndex } = swiper;

      setCurSlideIndex(activeIndex);
      if (id === 'quiz-details') {
        dispatch(quizChanged({ seq: list[activeIndex].seq }));
      }
    },
    onTransitionEnd(swiper) {
      const prevElement = swiper.slides[swiper.previousIndex];
      const nextElement = swiper.slides[swiper.activeIndex + 1];

      if (prevElement) prevElement.style.opacity = '0';
      if (nextElement) nextElement.style.opacity = '0';
    },
  };

  const Content = {
    'quiz-details': QuizDetails,
  }[id];

  const closeModal = () => {
    toggleModal({ id, type });

    if (id === 'quiz-details') {
      dispatch(quizChanged({ seq: null }));
    }
  };

  const handleClose = () => {
    if (id === 'quiz-details') {
      dispatch(quizChanged({ seq: null }));
    }
  };

  const openViewer = () => {
    openSelpubCloud(
      'viewer',
      projectId,
      false,
      list[curSlideIndex].page.toString()
    );
  };

  return (
    <Modal id={id} type={type} onClose={handleClose}>
      <div className={cx('top')}>
        <h2 className={cx('tit')}></h2>
        <div className={cx('btn_wrap')}>
          <Button
            name={CLOSE_POPUP}
            classnames={['pop_close', 'modal']}
            handleClick={closeModal}
            isBlindName={true}
          >
            <i className={cx('svg_i')}></i>
          </Button>
        </div>
      </div>

      <div className={cx('content')}>
        <div className={cx('slide_area')}>
          <div className={cx('slide_content')}>
            <Swiper {...swiperOptions}>
              {list.map((data: any) => (
                <SwiperSlide key={data?.seq} tag="li">
                  {Content && <Content data={data} />}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {isMobile || (
            <div className={cx('slide_nav')}>
              <button ref={prevElRef} className={cx('slide_prev')}>
                <span className={cx('blind')}>{PREV}</span>
              </button>
              <button ref={nextElRef} className={cx('slide_next')}>
                <span className={cx('blind')}>{NEXT}</span>
              </button>
            </div>
          )}
        </div>

        <div className={cx('btn_wrap', 'tac')}>
          <button
            type="button"
            className={cx('btn', 'b_t')}
            onClick={openViewer}
          >
            <span>{name}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
